module.exports = __webpack_public_path__ + "media/images/offline_icon-b27a0130146892e9719ecafd53c9a229.png";